import {
  createAccordionInteractionBlock,
  ImageChoice,
} from 'factories/interactions/accordion';
import { createImageInteractionBlock } from 'factories/interactions/image';
import { createCarouselInteractionBlock } from 'factories/interactions/carousel';
import { createFlipcardInteractionBlock } from 'factories/interactions/flipcard';
import { createFullPageTextBlock } from 'factories/interactions/fullpagetext';
import { createMultichoiceInteractionBlock } from 'factories/interactions/multichoice';
import { createMultichoiceImageInteractionBlock } from 'factories/interactions/multichoiceimage';
import { createSortationInteractionBlock } from 'factories/interactions/sortation';
import { createDragAndDropInteractionBlock } from 'factories/interactions/draganddrop';
// import { createMatchingInteractionBlock } from 'factories/interactions/matching';
import { createMatchingInteractionBlock } from 'factories/interactions/matching_v2';
import { createHotSpotInteractionBlock } from 'factories/interactions/hotspot';
import { createFiveStarRatingInteractionBlock } from 'factories/interactions/fivestarrating';
import { createResultsPageInteractionBlock } from 'factories/interactions/resultspage';
import { createClickAndRevealInteractionBlock } from 'factories/interactions/clickandreveal';
import { createTopicPortalInteractionBlock } from 'factories/interactions/topicportal';
import { createAssessmentInteractionBlock } from 'factories/interactions/assessment';
import { createAssessmentIntroductionInteractionBlock } from 'factories/interactions/assessmentintroduction';
import { createAssessmentQuestionInteractionBlock } from 'factories/interactions/assessmentquestion';
import { createAssessmentResultsInteractionBlock } from 'factories/interactions/assessmentresults';
import { createContentCardInteractionBlock } from 'factories/interactions/contentcard';
import { createTextEntryInteractionBlock } from 'factories/interactions/textentry';
import { createTextEntryVariableInteractionBlock } from 'factories/interactions/textentryvariable';
import { createTextEntryQuizInteractionBlock } from 'factories/interactions/textentryquiz';
import { createSelectOptionsInteractionBlock } from 'factories/interactions/selectoptions';
import { createSliderInteractionBlock } from 'factories/interactions/slider';
import { createCertificateInteractionBlock } from 'factories/interactions/certificate';

import { addInteraction } from 'factories/topic';
import store from 'store/next';
import { flatten } from 'factories/utils';
import { getBlock, getInteractionsFromTopicAndState } from 'selectors/block';
import { ContainerProperties } from './NewSectionWizard';
import { InteractionProps } from 'factories/interactions/interaction';
import postHogService from 'services/analytics/postHogService';

const ccount = {
  center: 0,
  centerReversed: 0,
  left: 1,
  right: 1,
};
const creversed = {
  center: false,
  centerReversed: true,
  // center: true,
  // centerReversed: false,
  left: false,
  right: true,
  // left: true,
  // right: false,
};

const transformProperties = (
  name: string,
  props: ContainerProperties
): InteractionProps => ({
  name,
  columnCount: ccount[props.layout],
  columnsReversed: creversed[props.layout],
  style: {
    background: props.background,
    foreground: props.textColor,
    buttonBackground: props.buttonColor,
    buttonForeground: props.buttonTextColor,
  },
});

const newInteractions = {
  accordion({
    numberOfItems = 3,
    layout,
    containerProperties,
    name,
    ...interactionProperties
  }) {
    return createAccordionInteractionBlock({
      ...containerProperties,
      name,
      numberOfAccordions: numberOfItems,
      imgChoice: {
        left: ImageChoice.Left,
        right: ImageChoice.Right,
        fill: ImageChoice.Right,
        none: ImageChoice.None,
      }[layout || 'left'],
      ...interactionProperties,
    });
  },
  image({ name, layout, containerProperties, ...interactionProperties }) {
    return createImageInteractionBlock({
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  carousel({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    return createCarouselInteractionBlock({
      numberOfSlides: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'flip card'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createFlipcardInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  'full page text'({
    name,
    numberOfItems = 1,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    return createFullPageTextBlock({
      numberOfSlides: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'content cards'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    return createContentCardInteractionBlock({
      numberOfCards: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'multiple choice'({
    numberOfItems = 3,
    layout,
    containerProperties,
    name,
    ...interactionProperties
  }) {
    return createMultichoiceInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'multiple choice media'({
    numberOfItems = 3,
    layout,
    containerProperties,
    name,
    ...interactionProperties
  }) {
    return createMultichoiceInteractionBlock({
      // createMultichoiceImageInteractionBlock
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  sortation({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    // console.log('sortation name', name);
    return createSortationInteractionBlock({
      answerCount: numberOfItems,
      layout,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  slider({
    // numberOfItems = 3,
    layout,
    containerProperties,
    name,
    ...interactionProperties
  }) {
    return createSliderInteractionBlock({
      answerCount: 0,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'drag and drop'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    return createDragAndDropInteractionBlock({
      answerCount: numberOfItems,
      layout,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  matching({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    return createMatchingInteractionBlock({
      answerCount: numberOfItems,
      layout,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  hotspot({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    //
    return createHotSpotInteractionBlock({
      answerCount: numberOfItems,
      layout,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  '5 star rating'({
    name,
    numberOfItems = 0,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    //
    return createFiveStarRatingInteractionBlock({
      answerCount: numberOfItems,
      layout,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'results page'({
    name,
    numberOfItems = 0,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    //
    return createResultsPageInteractionBlock({
      answerCount: numberOfItems,
      layout,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  certificate({
    name,
    numberOfItems = 0,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    //
    return createCertificateInteractionBlock({
      answerCount: numberOfItems,
      layout,
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'click and reveal'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createClickAndRevealInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  'landing page'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createClickAndRevealInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  'text entry'({
    name,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    //createTextEntryInteractionBlock
    return createFiveStarRatingInteractionBlock({
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'text entry variable'({
    name,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    return createTextEntryVariableInteractionBlock({
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'text entry quiz'({
    name,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    //createTextEntryInteractionBlock
    return createTextEntryQuizInteractionBlock({
      ...containerProperties,
      name,
      ...interactionProperties,
    });
  },
  'select options'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createSelectOptionsInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  'topic portal'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createTopicPortalInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  assessment({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createAssessmentInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  'assessment introduction'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createAssessmentIntroductionInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  'assessment question'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createAssessmentQuestionInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
  'assessment results'({
    name,
    numberOfItems = 3,
    layout,
    containerProperties,
    ...interactionProperties
  }) {
    const data = createAssessmentResultsInteractionBlock({
      answerCount: numberOfItems,
      ...containerProperties,
      name,
      ...interactionProperties,
    });

    return data;
  },
};

const createInteraction = ({
  blocks,
  topic,
  containerProperties,
  interactionProperties,
  setBlocks,
  setBlock,
}) => {
  const topicBlock = getBlock(blocks, topic.id);
  const p = transformProperties('', containerProperties);

  let { type } = interactionProperties;

  if (type === 'hotspot quiz') {
    type = 'hotspot';
  }

  if (type === 'hotspot landing page') {
    type = 'hotspot';
  }

  const newInteraction = newInteractions[type]({
    containerProperties: p,
    ...interactionProperties,
  });

  const [newBlocks, rootId] = flatten(newInteraction);

  const newInteractionRef = {
    type: 'Ref',
    id: rootId,
  };

  const newTopicBlock = addInteraction(blocks)(
    topicBlock,
    newInteractionRef,
    getInteractionsFromTopicAndState(store.getState() as any, topicBlock).length
  );

  const isAssessment = type.startsWith('assessment');
  const trackingLabel = isAssessment
    ? 'assessment_interaction_added'
    : 'interaction_added';
  postHogService.track(trackingLabel, {
    interaction_type: type,
  });

  newBlocks[newTopicBlock.id] = newTopicBlock;
  setBlocks(newBlocks);
};

export default createInteraction;
